import { displayDateOnly, displayTime } from '@/helpers/ag-grid/cellFormats'

import { timeHeader } from '@/helpers/ag-grid/headerFormats'

export default [
    {
        headerName: 'Batch ID',
        field: 'batchId',
        hide: true,
    },
    {
        headerName: 'Date',
        field: 'startTime', //using startTime because the DB value for date doesn't have a timezone
        width: 140,
        sort: 'desc',
        valueFormatter: (params) => displayDateOnly(params.value),
    },
    {
        headerName: timeHeader('Start Time'),
        field: 'startTime',
        valueFormatter: (params) => displayTime(params.value),
        width: 175,
        /**
         * sorting doesn't work here because the Date field above is using the same field (startTime)
         * so ag grid renames this field to startTime_1. When passed to the backend it cannot find the
         * field name startTime_1. Also, sorting on Date sorts this field too (because they are the same)
         */
        sortable: false,
        filter: false,
    },
    {
        headerName: timeHeader('End Time'),
        field: 'endTime',
        valueFormatter: (params) => displayTime(params.value),
        width: 175,
        filter: false,
    },
    {
        headerName: 'Inserted',
        cellRendererFramework: 'RowButton',
        cellRendererParams: {
            buttonParams: {
                routerLinkIds: ['batchId'],
                routeName: 'import-log-results',
                query: { agFilters: { recordsInserted: 0 } },
            },
        },
        filter: 'agNumberColumnFilter',
        filterParams: {
            filterOptions: ['greaterThan'],
            defaultOption: 'greaterThan',
        },
        field: 'recordsInserted',
        width: 150,
    },
    {
        headerName: 'Updated',
        cellRendererFramework: 'RowButton',
        cellRendererParams: {
            buttonParams: {
                routerLinkIds: ['batchId'],
                routeName: 'import-log-results',
                query: { agFilters: { recordsUpdated: 0 } },
            },
        },
        filter: 'agNumberColumnFilter',
        filterParams: {
            filterOptions: ['greaterThan'],
            defaultOption: 'greaterThan',
        },
        field: 'recordsUpdated',
        width: 150,
    },
    {
        headerName: 'Errors',
        cellRendererFramework: 'RowButton',
        cellRendererParams: {
            buttonParams: {
                routerLinkIds: ['batchId'],
                routeName: 'import-log-results',
                color: 'error',
                query: { agFilters: { errors: 0 } },
            },
        },
        filter: 'agNumberColumnFilter',
        filterParams: {
            filterOptions: ['greaterThan'],
            defaultOption: 'greaterThan',
        },
        field: 'errors',
        width: 150,
    },
    {
        headerName: 'Warnings',
        cellRendererFramework: 'RowButton',
        cellRendererParams: {
            buttonParams: {
                routerLinkIds: ['batchId'],
                routeName: 'import-log-results',
                color: 'warning',
                query: { agFilters: { warnings: 0 } },
            },
        },
        filter: 'agNumberColumnFilter',
        filterParams: {
            filterOptions: ['greaterThan'],
            defaultOption: 'greaterThan',
        },
        field: 'warnings',
        width: 150,
    },
    {
        headerName: 'Records Processed',
        field: 'recordsProcessed',
        cellRendererFramework: 'ChipCellNumber',
        cellRendererParams: {
            color: 'primary',
        },
    },
    {
        headerName: 'Total Files',
        field: 'filesProcessed',
        cellRendererFramework: 'ChipCellNumber',
        cellRendererParams: {
            color: 'primary',
        },
    },
    {
        headerName: 'Action',
        cellRendererFramework: 'RowButton',
        cellRendererParams: {
            buttonParams: {
                routerLinkIds: ['batchId'],
                routeName: 'import-log-results',
                btnText: 'Results',
                color: '',
            },
        },
        filter: false,
        width: 140,
        pinned: 'right',
        lockPinned: true,
        lockVisible: true,
        lockPosition: true,
        hide: false,
        suppressMenu: true,
        sortable: false,
    },
]
